const App = {
  yzj: 'yunzhijia',
  yzjDesktop: 'yunzhijia_desktop',
  yzjOldDesktop: 'yunzhijia_old_desktop',
  wx: 'weixin',
  dd: 'dingding',
  wxwork: 'wxwork',
  welink: 'welink',
  feishu: 'feishu',
  unknown: 'unknown'
}

export function isYzj() {
  const agent = navigator.userAgent;
  return /Qing\/.*;(iOS|iPhone|Android|iPadOS|Harmony)/.test(agent);
}

export function isYzjDesktop() {
  const agent = navigator.userAgent;
  return /App\/cloudhub/.test(agent);
}

export function isYzjOldDesktop() {
  const agent = navigator.userAgent;
  return /clientId:10204/.test(agent);
}

export function isWX() {
  const agent = navigator.userAgent;
  return agent.indexOf('MicroMessenger') > -1 && agent.indexOf('wxwork') < 0;
}

export function isWxWork() {
  const agent = navigator.userAgent;
  return agent.indexOf('MicroMessenger') > -1 && agent.indexOf('wxwork') > -1;
}

export function isDD() {
  const agent = navigator.userAgent;
  const _isDD = agent.indexOf('DingTalk') > -1;
  const isDDMiniProgram = agent.indexOf('MiniProgram') === -1 && agent.indexOf('dd-web') === -1;
  return _isDD && isDDMiniProgram;
}

export function isWeLink() {
  const agent = navigator.userAgent;
  return agent.indexOf('welink') > -1 || agent.indexOf('cloudlink') > -1;
}

export function isFeiShu() {
  const agent = navigator.userAgent;
  return agent.indexOf('Lark/') > -1;
}

export function getApp() {
  if (isYzj()) return App.yzj;
  else if (isYzjDesktop()) return App.yzjDesktop;
  else if (isYzjOldDesktop()) return App.yzjOldDesktop;
  else if (isWX()) return App.wx;
  else if (isWxWork()) return App.wxwork;
  else if (isDD()) return App.dd;
  else if (isWeLink) return App.welink;
  else if (isFeiShu()) return App.feishu;
  else return App.unknown;
}

export default getApp;
